import { setToken, setRole } from "../utils/auth";

import { API_BASE_URL } from './URL_Header';

export const login = async (loginData) => {
  try {
    const response = await fetch(`${API_BASE_URL}/auth/Login`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(loginData),
    });
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || "فشل تسجيل الدخول");
    }
    const data = await response.json();
    setToken(data.token);
    setRole(data.role || "User"); // Default to "User" if role is not provided
    return {
      token: data.token,
      role: data.role || "User",
      message: "تم تسجيل الدخول بنجاح"
    };
  } catch (err) {
    throw new Error(err.message || "فشل تسجيل الدخول");
  }
};

// New function to validate token
export const validateToken = async (token) => {
  try {
    const response = await fetch(`${API_BASE_URL}/auth/ValidateToken`, {
      method: "GET",
      headers: {
        "Authorization": `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || "Token is invalid or expired");
    }
    return await response.json(); // Returns validation result (e.g., { isValid: true })
  } catch (err) {
    throw new Error(err.message || "Token validation failed");
  }
};